import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getError, getIsLoading } from 'store/selectors/admin';
import UserManagement from './UserManagement';
import { getUserDetails } from '../../../store/selectors/auth';
import React, { useState, useMemo } from 'react';
import { useQueryGetUsers, useQueryTotalUsers } from '../../../query/user';
import {
  useCreateUser,
  useDeleteUser,
  useResetUserPassword,
  useUpdateUser,
} from '../../../mutation/user';
import useDebounce from 'hooks/useDebounce';

const selector = createStructuredSelector({
  isLoading: getIsLoading,
  error: getError,
  currentUser: getUserDetails,
});

export default function(props) {
  const selectorProps = useSelector(selector);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [role, setRole] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search],
  );

  const variables = {
    page,
    limit,
    search: debouncedSearch,
  };

  if (role) {
    variables.role = role;
  }

  const {
    data: totalUserData,
    isFetching: totalUserLoading,
  } = useQueryTotalUsers(variables);
  const { data, isFetching, refetch } = useQueryGetUsers(variables);

  const { mutate: mutateCreateUser, ...createUserMutation } = useCreateUser();
  const { mutate: mutateUpdateUser, ...updateUserMutation } = useUpdateUser();
  const { mutate: mutateDeleteUser, ...deleteUserMutation } = useDeleteUser();
  const {
    mutate: mutateResetPassword,
    ...resetPasswordMutation
  } = useResetUserPassword();

  const isLoading =
    isFetching ||
    totalUserLoading ||
    createUserMutation.isLoading ||
    updateUserMutation.isLoading ||
    deleteUserMutation.isLoading ||
    resetPasswordMutation.isLoading;

  return useMemo(() => {
    return (
      <UserManagement
        {...props}
        {...selectorProps}
        isLoading={isLoading}
        limit={limit}
        page={page}
        refetchUsersList={refetch}
        setLimit={setLimit}
        setPage={setPage}
        setRole={setRole}
        setSearch={setSearch}
        totalUsers={totalUserData}
        users={data}
        onAddUser={mutateCreateUser}
        onDeleteUser={mutateDeleteUser}
        onResetUserPassword={mutateResetPassword}
        onUpdateUser={mutateUpdateUser}
      />
    );
  }, [page, limit, selectorProps, props, data, totalUserData, isLoading]);
}
